import React, { useCallback, useEffect, useState } from "react";
import Header from "../components/Header";
import {
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  Modal,
  Switch,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ModalError from "../components/Generics/ModalError";
import { actions, logout, service } from "../model";
import ModalConferma from "../components/Generics/ModalConferma";
import axios from "axios";

const HomeAdmin = ({ isToolsDomain }) => {
  const reduxObject = JSON.parse(localStorage.getItem("redux_object") || "{}");
  const practices = useSelector(
    (state) => state.user?.redux_object?.practices || [],
  );

  const user = useSelector((state) => state.user?.redux_object.user || []);
  const [isAdmin, setIsAdmin] = useState(user?.admin === 1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const approvedPractices = practices.filter(
    (practice) => practice.practice_worked === 1,
  );

  const pendingPractices = practices.filter(
    (practice) => practice.practice_worked === 0 && practice.status === "sent",
  );

  const dispatch = useDispatch();

  const [visibleSectionApproved, setVisibleSectionApproved] = useState(false);
  const [visibleSectionPending, setVisibleSectionPending] = useState(false);

  const toggleSectionApproved = useCallback(() => {
    setVisibleSectionApproved((prev) => !prev);
  }, []);

  const toggleSectionPending = useCallback(() => {
    setVisibleSectionPending((prev) => !prev);
  }, []);

  useEffect(() => {
    if (user?.admin !== undefined) {
      setIsAdmin(user.admin === 1);
    }
  }, [user]);

  // OLD CHANGE-ROLE bug - return 401 nessun logout
  // const changeRoleUser = async () => {
  //   const accessToken = reduxObject ? reduxObject.accessToken : null;

  //   try {
  //     const response = await axios.get(
  //       process.env.REACT_APP_API_ENDPOINT + "change-role",
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //           Authorization: "Bearer " + accessToken,
  //         },
  //       },
  //     );

  //     if (response.status === 200) {
  //       const token = localStorage.getItem("token");
  //       const email = localStorage.getItem("email");

  //       dispatch(actions.loginLexiaTools(token, email));
  //     }

  //     return response.data;
  //   } catch (error) {
  //     console.error("Errore durante il cambio ruolo:", error);
  //     throw error;
  //   }
  // };

  const changeRoleUser = async () => {
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + "change-role",
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + accessToken,
          },
        },
      );
      if (response.status === 200) {
        const token = localStorage.getItem("token");
        const email = localStorage.getItem("email");
        dispatch(actions.loginLexiaTools(token, email));
      }

      return response.data;
    } catch (error) {
      console.error("Errore durante il cambio ruolo:", error);

      if (error?.response?.status === 401) {
        window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
        return;
      }

      throw error;
    }
  };

  const handleToggle = async (event) => {
    setIsAdmin(event.target.checked);

    dispatch({ type: "GLOBAL_LOADING_START" });

    try {
      await changeRoleUser();

      const id_token = localStorage.getItem("id_token");
      const access_token = localStorage.getItem("access_token");
      const email_user = localStorage.getItem("email_user");

      if (id_token && access_token && email_user) {
        await dispatch(
          actions.loginLexiaTools(email_user, id_token, access_token),
        );
      }
    } catch (error) {
      console.error("Errore nel cambio ruolo", error);
    } finally {
      setTimeout(() => {
        dispatch({ type: "GLOBAL_LOADING_STOP" });
      }, 3000);
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress style={{ color: "#1b2838" }} />
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <div
          style={{
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 1000,
          }}
        >
          <Header user={user} />
        </div>

        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <Grid
            item
            container
            xs={11}
            sm={10}
            spacing={4}
            sx={{
              marginTop: { xs: "80px", md: "120px" },
              marginBottom: "30px",
              display: "flex",
              height: "30px",
              justifyContent: "center",
            }}
          >
            {pendingPractices.length !== 0 && (
              <>
                {/* INVIATE  */}

                <Grid
                  item
                  xs={11}
                  md={8}
                  style={{
                    display: "flex",
                    marginTop: "0px",
                    paddingBottom: "20px",
                  }}
                >
                  <Grid item xs={11}>
                    {" "}
                    {pendingPractices.length > 0 ? (
                      <Typography
                        className="color-blue-dark"
                        sx={{
                          fontSize: {
                            xs: "18px !important",
                            sm: "20px !important",
                            md: "22px !important",
                          },
                          fontWeight: 600,
                        }}
                      >
                        Richieste da lavorare
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <div onClick={toggleSectionPending}>
                      <div
                        className={
                          visibleSectionPending
                            ? "icon-less-practice"
                            : "icon-plus-practice"
                        }
                      />
                    </div>
                  </Grid>
                </Grid>

                {pendingPractices
                  .slice()
                  .reverse()
                  .map((practice, index) => {
                    let parsedPractice = practice.practice;

                    try {
                      while (typeof parsedPractice === "string") {
                        parsedPractice = JSON.parse(parsedPractice);
                      }
                    } catch (error) {
                      console.error(error);
                      parsedPractice = {};
                    }

                    const datePart = new Date(
                      practice.updated_at,
                    ).toLocaleDateString("it-IT", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    });

                    const timePart = new Date(
                      practice.updated_at,
                    ).toLocaleTimeString("it-IT", {
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                    return (
                      <Grid
                        item
                        xs={11}
                        md={8}
                        component={Link}
                        to={`/practice/${practice.id}`}
                        key={practice.id}
                        style={{
                          paddingTop: "25px",
                          display: visibleSectionPending ? "block" : "none",
                          textDecoration: "none",
                        }}
                      >
                        <div className="card_practice">
                          <Link
                            to={`/practice/${practice.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                marginBottom: "0px",
                                fontSize: "16px",
                                marginLeft: "20px",
                                marginRight: "20px",
                              }}
                            >
                              #{practice.id} -{" "}
                              {parsedPractice?.Incarico?.Nome_pratica || "N/A"}{" "}
                              - Inviata il {datePart} alle {timePart}{" "}
                            </Typography>
                            <Typography variant="body2"></Typography>
                          </Link>
                        </div>
                      </Grid>
                    );
                  })}
              </>
            )}

            {approvedPractices.length !== 0 && (
              <>
                {/* APPROVATE  */}
                <Grid
                  item
                  xs={11}
                  md={8}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: "20px",
                  }}
                >
                  <Grid item xs={11}>
                    {" "}
                    {approvedPractices.length > 0 ? (
                      <Typography
                        className="color-blue-dark"
                        sx={{
                          fontSize: {
                            xs: "18px !important",
                            sm: "20px !important",
                            md: "22px !important",
                          },
                          fontWeight: 600,
                        }}
                      >
                        Richieste approvate
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <div onClick={toggleSectionApproved}>
                      <div
                        className={
                          visibleSectionApproved
                            ? "icon-less-practice"
                            : "icon-plus-practice"
                        }
                      />
                    </div>
                  </Grid>
                </Grid>

                {approvedPractices
                  .slice()
                  .reverse()
                  .map((practice) => {
                    let parsedPractice = practice.practice;

                    try {
                      while (typeof parsedPractice === "string") {
                        parsedPractice = JSON.parse(parsedPractice);
                      }
                    } catch (error) {
                      console.error(error);
                      parsedPractice = {};
                    }

                    const datePart = new Date(
                      practice.updated_at,
                    ).toLocaleDateString("it-IT", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    });

                    const timePart = new Date(
                      practice.updated_at,
                    ).toLocaleTimeString("it-IT", {
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                    return (
                      <Grid
                        item
                        xs={11}
                        md={8}
                        component={Link}
                        to={`/practice/${practice.id}`}
                        key={practice.id}
                        style={{
                          paddingTop: "25px",
                          width: "100%",
                          display: visibleSectionApproved ? "block" : "none",
                          textDecoration: "none",
                        }}
                      >
                        <div className="card_practice">
                          <Link
                            to={`/practice/${practice.id}`}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              width: "100%",
                            }}
                          >
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                marginBottom: "0px",
                                fontSize: "16px",
                                marginLeft: "20px",
                                marginRight: "20px",
                              }}
                            >
                              #{practice.id} -{" "}
                              {parsedPractice?.Incarico?.Nome_pratica || "N/A"}{" "}
                              - Approvata il {datePart} alle {timePart}{" "}
                            </Typography>
                            <Typography variant="body2"></Typography>
                          </Link>
                        </div>
                      </Grid>
                    );
                  })}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={8}
                  style={{
                    marginTop: "80px",
                  }}
                />
              </>
            )}

            {approvedPractices.length === 0 &&
              pendingPractices.length === 0 && (
                <div
                  style={{
                    width: "500px",
                    marginTop: "50px",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    textAlign: "center",
                    alignItems: "center",
                    marginLeft: "30px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{
                      fontSize: "24px",
                      fontWeight: 600,
                      marginBottom: "30px",
                    }}
                  >
                    Nessuna richiesta
                  </Typography>

                  <div className="empty_practice" />
                </div>
              )}
          </Grid>
        </Grid>

        {/* box button  */}

        {user &&
        (isToolsDomain
          ? [1, 91].includes(user.id)
          : [1, 2, 3, 6].includes(user.id)) ? (
          <Grid
            container
            className="bg-blue-dark"
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "15px 0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "69px",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px 0px",
              }}
            >
              <Grid
                item
                xs={6}
                sm={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  padding: "0px 0px",
                }}
              >
                {/* sistemare css se utente non è FD  */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "15px",
                  }}
                >
                  <Switch
                    checked={isAdmin}
                    onChange={handleToggle}
                    sx={{
                      width: { xs: 46 },
                      height: 20,
                      padding: 0,
                      "& .MuiSwitch-switchBase": {
                        padding: 0.5,
                        "&.Mui-checked": {
                          transform: "translateX(26px)",
                          color: "#fff",
                          "& + .MuiSwitch-track": {
                            backgroundColor: "#bc2957",
                            opacity: 1,
                          },
                        },
                      },
                      "& .MuiSwitch-thumb": {
                        width: 12,
                        height: 12,
                      },
                      "& .MuiSwitch-track": {
                        borderRadius: 34 / 2,
                        backgroundColor: "rgba(211, 211, 211, 0.76)",
                        opacity: 1,
                        transition: "background-color 0.2s",
                      },
                    }}
                  />
                  <Typography
                    className="color-light"
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "12px", sm: "14px" },
                      fontWeight: 500,
                      marginLeft: { xs: "5px", sm: "10px" },
                    }}
                  >
                    {isAdmin
                      ? "Profilo Approver attivo"
                      : "Profilo Approver disattivato"}
                  </Typography>
                </div>
              </Grid>
              <Grid
                item
                xs={5.5}
                sm={6.5}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "end", sm: "start" },
                  alignItems: "center",
                  padding: "0px 0px",
                  marginRight: "10px",
                }}
              ></Grid>
            </Grid>
          </Grid>
        ) : null}
      </div>
    </>
  );
};

export default HomeAdmin;
